import React from 'react';
import { createPortal } from 'react-dom';
import { clsx } from 'clsx';
import { ModalStackIncrement, useModalZIndex } from '@/contexts/ModalStackContext';

/**
 * Full-screen modal overlay with automatic z-index stacking for nested modals.
 */
export function ModalShell({ open, children, className, overlayClassName, portal = true }) {
  const zIndex = useModalZIndex();

  if (!open) return null;

  const content = (
    <ModalStackIncrement>
      <div
        className={clsx(
          'fixed inset-0 flex items-center justify-center bg-black/50 p-4 sm:p-6',
          overlayClassName
        )}
        style={{ zIndex }}
      >
        {children}
      </div>
    </ModalStackIncrement>
  );

  if (portal && typeof document !== 'undefined') {
    return createPortal(content, document.body);
  }

  return content;
}
